import { gql } from '@apollo/client';
const GET_PRODUCT_CONTINENTS = gql `
  query GetProductContinents($first: Int = 25, $after: String = "") {
    autocomplete {
      productContinents(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            name
            description
            thumbnail
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_CONTINENTS;
